import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/ServerlessPastPresentFuturePage.head';
import { ServerlessPastPresentFuturePage } from '@pages/ServerlessPastPresentFuturePage';

export const Route = createFileRoute('/serverless-past-present-future')({
  component: ServerlessPastPresentFuturePage,
  head: () => head,
});
